(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["furry-muse-main"] && !Shopify.designMode) return;
  try {
    

/* Furry Muse — shared helpers (toast + add to cart). Blocks call window.FurryMuse.*
   Add to bag writes to the store's ONE custom bag (window.SolaraCart, see snippets/furry-cart.liquid),
   NOT to Shopify's /cart — so pet and human products end up in the same bag. */
window.FurryMuse = window.FurryMuse || (() => {
  let toastTimer;

  const announce = (message) => {
    const toast = document.querySelector('[data-pa-toast]');
    if (!toast) return;
    const output = toast.querySelector('[data-pa-toast-message]');
    if (output) output.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3500);
  };

  // Builds a bag item from an element's data attributes (the "add" buttons / hotspots carry them):
  // data-variant-id, data-title, data-variant-title, data-price-cents, data-image, data-url, data-category
  const itemFrom = (el, extra) => {
    const d = el.dataset;
    return Object.assign({
      id: Number(d.variantId),
      quantity: 1,
      title: d.title,
      variantTitle: d.variantTitle,
      priceCents: Number(d.priceCents),
      image: d.image,
      url: d.url,
      category: d.category || undefined
    }, extra);
  };

  // items: [{ id, quantity, title, variantTitle, priceCents, image, url, category }]
  const addToCart = async (items, okMessage, button) => {
    if (button) button.disabled = true;
    try {
      if (!window.SolaraCart) throw new Error('The bag is not available. Please refresh the page.');
      items.forEach((item) => window.SolaraCart.add(item));
      announce(okMessage);
    } catch (err) {
      announce(err.message);
    } finally {
      if (button) window.setTimeout(() => { button.disabled = false; }, 1000);
    }
  };

  // Run fn once the DOM is parsed (custom elements can connect before their children exist)
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  return { announce, addToCart, itemFrom, ready };
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-furry-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd-header')) {
    class PdHeader extends HTMLElement {
      connectedCallback() {
        // Publish the real header height so the sticky buy box always sits just below it.
        const root = this.closest('.pd-main');
        const publishHeight = () => {
          if (root) root.style.setProperty('--pd-header-h', this.offsetHeight + 'px');
        };
        publishHeight();
        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(publishHeight);
          this._ro.observe(this);
        } else {
          window.addEventListener('resize', publishHeight);
        }
        this._onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 24);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();
        // The bag badge ([data-solara-cart-count]) is kept live by window.SolaraCart (snippets/furry-cart.liquid).
        if (window.SolaraCart) window.SolaraCart.updateBadges();
      }
      disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
        window.removeEventListener('scroll', this._onScroll);
      }
    }
    customElements.define('pd-header', PdHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
